import React, { Component } from 'react';
import CheckboxTree from 'react-checkbox-tree';
import _ from 'lodash';

import GenericButton from './GenericButton';
import clearIcon from '../../images/clear-field-icon.png';
import clearIconBlue from '../../images/clear-field-icon_b.png';
import searchIcon from '../../images/search-icon.png';

class FilterSearchComponent extends Component {
  constructor() {
    super();

    this.state = {
      searchText: '',
      checked: [],
      expanded: [],
      selected: [],
      nodes: [],
      msgDisplay: false,
      prevSearchText: '',
    };
  }

  onChecked = checked => {
    const { getSelFilterFn } = this.props;
    const selectedItems = _.cloneDeep(this.state.selected);
    const checkedItems = _.cloneDeep(this.state.checked);
    checked.map(checkedVal => {
      if (_.find(this.state.selected, { value: checkedVal }) === undefined) {
        selectedItems.push(_.find(this.state.nodes, { value: checkedVal }));
        checkedItems.push(checkedVal);
      }
      return false;
    });
    selectedItems.map(selectedVal => {
      if (
        _.indexOf(checked, selectedVal.value) < 0 &&
        _.find(this.state.nodes, { value: selectedVal.value }) !== undefined
      ) {
        const itemIndex = _.findIndex(selectedItems, {
          value: selectedVal.value,
        });
        selectedItems.splice(itemIndex, 1);
        checkedItems.splice(itemIndex, 1);
      }
      return false;
    });
    this.setState({
      checked: checkedItems,
      selected: selectedItems,
    }, () => {
      if (getSelFilterFn !== undefined) {
        getSelFilterFn(selectedItems);
      }
    });
  };

  removeFilterItem = value => {
    const { getSelFilterFn } = this.props;
    const selectedItems = _.cloneDeep(this.state.selected);
    const checkedItems = _.cloneDeep(this.state.checked);
    const itemIndex = _.findIndex(selectedItems, { value });
    selectedItems.splice(itemIndex, 1);
    checkedItems.splice(itemIndex, 1);
    this.setState({
      checked: checkedItems,
      selected: selectedItems,
    }, () => {
      if (getSelFilterFn !== undefined) {
        getSelFilterFn(selectedItems);
      }
    });
  };

  handleOnChange = () => {
    this.setState({ searchText: this.searchBox.value });
  };

  handleKeyPress = e => {
    if (e.key === 'Enter' && this.state.searchText.length !== 0) {
      this.handleSearch();
    }
  };

  handleSearch = () => {
    this.setState({ msgDisplay: false, prevSearchText: this.state.searchText });
    this.props.searchFilterFn(this.state.searchText, response => {
      if (response.length > 0) {
        this.setState({
          msgDisplay: false,
          nodes: response,
        });
      } else {
        this.setState({
          msgDisplay: true,
          nodes: [],
        });
      }
    });
  };

  handleClear = () => {
    this.searchBox.value = '';
    this.handleOnChange();
  };

  handleApply = () => {
    this.props.applyFilterFn(
      _.isEqual(this.props.selectedFilter, this.state.selected)
        ? ''
        : this.state.selected,
    );
  };

  handleClose = () => {
    this.props.closeFilterBox();
  };

  UNSAFE_componentWillMount() {
    if (this.props.selectedFilter.length > 0) {
      const tempCheckedItems = [];
      this.props.selectedFilter.map(item => {
        tempCheckedItems.push(item.value);
        return false;
      });
      this.setState({
        checked: tempCheckedItems,
        selected: this.props.selectedFilter,
      });
    }
    if (this.props.resetNodes) {
      this.setState({
        searchText: '',
        nodes: [],
      });
      this.handleClear();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.resetNodes) {
      this.setState({
        searchText: '',
        nodes: [],
      });
      this.handleClear();
    }

    if (nextProps.selectedFilter) {
      if (nextProps.selectedFilter.length > 0) {
        const tempCheckedItems = [];
        nextProps.selectedFilter.map(item => {
          tempCheckedItems.push(item.value);
          return false;
        });
        this.setState({
          checked: tempCheckedItems,
          selected: nextProps.selectedFilter,
        });
      } else {
        this.setState({
          checked: [],
          selected: [],
        });
      }
    }
  }

  render() {
    const showSelectedFilters = this.state.selected.map(filter => (
      <span
        className="fsc-filter-Item"
        key={filter.value}
        title={filter.label}
      >
        <img
          src={clearIconBlue}
          alt="clear"
          className="fsc-remove-icon"
          onClick={() => this.removeFilterItem(filter.value)}
        />{' '}
        &nbsp;{filter.label}
      </span>
    )
    );
    return (
      <div className="filter-search-component" style={this.props.additionalStyles !== undefined ? this.props.additionalStyles : {}}>
        {this.props.closeFilterBox !== undefined && <div className="text-right fsc-close">
          <img src={clearIcon} alt="Close" onClick={() => this.handleClose()} />
        </div>}
        <div className="fsc-search-bar">
          <input
            type="text"
            placeholder="search"
            onChange={this.handleOnChange}
            onKeyPress={e => this.handleKeyPress(e)}
            ref={searchBox => {
              this.searchBox = searchBox;
            }}
          />
          {(this.state.searchText.length === '' ||
            this.state.prevSearchText !== this.state.searchText) && (
            <button
              type="button"
              className="button"
              disabled={this.state.searchText.length === 0}
              onClick={this.handleSearch}
            >
              <img src={searchIcon} alt="search" />
            </button>
          )}

          {this.state.prevSearchText !== '' &&
            this.state.prevSearchText === this.state.searchText && (
            <button
              type="button"
              className="button"
              onClick={this.handleClear}
            >
              <img src={clearIconBlue} alt="clear" />
            </button>
            )}
        </div>
        <div className="clearfix padding-top-10">
          <div className={`${this.props.applyFilterFn !== undefined ? 'small-10 float-left' : 'small-12'}`}>
            <div className="fsc-filter-display">
              <span className="fsc-filter-label">Filters:</span>
              {showSelectedFilters}
              {this.state.selected.length === 0 && (
                <span className="fsc-filter-Item">All (Default)</span>
              )}
            </div>
          </div>
          {this.props.applyFilterFn !== undefined && <div className="small-2 float-right text-right">
            <GenericButton
              name="Apply"
              btnStyle="button small fsc-filter-btn"
              onBtnClick={this.handleApply}
            />
          </div> }
        </div>
        <div className="fsc-search-display">
          <CheckboxTree
            nodes={this.state.nodes}
            checked={this.state.checked}
            expanded={this.state.expanded}
            onCheck={checked => this.onChecked(checked)}
            showNodeTitle="true"
          />
          {this.state.msgDisplay && (
            <p className="fsc-search-msg">
              No Results Found. Please refine your search.
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default FilterSearchComponent;
